import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  PROPOSALS_SENT_REPORT_GET_LEAD_LIST: createSagaAction('PROPOSALS_SENT_REPORT_GET_LEAD_LIST'),
  PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST: createSagaAction(
    'PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST'
  ),
  PROPOSALS_SENT_REPORT_GET_FULL_REPORT: createSagaAction('PROPOSALS_SENT_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  proposalsSentReportGetLeadList: ({ filters }) => ({
    type: constants.PROPOSALS_SENT_REPORT_GET_LEAD_LIST.ACTION,
    filters
  }),
  proposalsSentReportGetOrganizationList: ({ filters }) => ({
    type: constants.PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST.ACTION,
    filters
  }),
  proposalsSentReportGetFullReport: ({ filters }) => ({
    type: constants.PROPOSALS_SENT_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.PROPOSALS_SENT_REPORT_GET_LEAD_LIST.ACTION:
      return { ...state, error: null, loadingLeadList: true }
    case constants.PROPOSALS_SENT_REPORT_GET_LEAD_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingLeadList: false,
        leadList: action.payload
      }
    case constants.PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST.ACTION:
      return { ...state, error: null, loadingOrganizationList: true }
    case constants.PROPOSALS_SENT_REPORT_GET_ORGANIZATION_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingOrganizationList: false,
        organizationList: action.payload
      }

    case constants.PROPOSALS_SENT_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.PROPOSALS_SENT_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/leads/proposalsSentReportActions.js